import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import { formatDateStringLocalDateINA } from "../../../utilities/Utils";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const DataUmumKapal = ({ dataDisposisi, dataPpmKapal }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const [inspeksi, setInspeksi] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)
    const [listDataIkan, setListDataIkan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            const results = await Promise.allSettled([
                kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal),
                kapalService.getMasterKapalById(dataPpmKapal.idKapal),
                kapalService.listKapalIkan(dataPpmKapal.nomorAjuKapal, 0, 10)
            ])

            const [resInspeksi, resMasterKapal, resKapalIkan] = results
            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            setInspeksi(getData(resInspeksi))
            setMasterKapal(getData(resMasterKapal))
            setListDataIkan(getData(resKapalIkan))

        } catch (error) {

        }

    }, [dataDisposisi, dataPpmKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, fetchAllData]);


    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>DATA UMUM KAPAL PERIKANAN</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { border: 1 }]}>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jenis Kapal Perikanan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.jenisKapal === '1' ? 'Penangkap' : 'Pembeku')}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Fasilitas Pembekuan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)')}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>3</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Kapal Perikanan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaKapal}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>4</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Pemilik</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '21%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{masterKapal && masterKapal.pemilik}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>5</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Nakhoda</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaNahkoda}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>6</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jumlah ABK</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '21%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.jumlahAbk}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>7</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ukuran Kapal (GT)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.ukuranKapal}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>8</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alat Tangkap</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '21%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.alatTangkap}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>9</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Daerah Penangkapan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.daerahTangkap}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>10</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Lama operasi penangkapan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '21%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.lamaOperasi}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>11</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Data logistik (ton)</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>- BBM</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>- Es</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>- Air</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{' '}</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.beratBbm}</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.beratEs}</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.beratAir}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>12</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '21%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{inspeksi && formatDateStringLocalDateINA(inspeksi.tglInspeksi)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>13</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '96%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ikan Hasil Tangkapan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jenis</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '37%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Segar</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '36%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Beku</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Berat (kg)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Suhu (°C)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Suhu palka (°C)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Nilai organoleptik</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Berat (kg)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Suhu (°C)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Suhu palka (°C)</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Nilai organoleptik</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { border: 1 }]}>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>a</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>b</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>c</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>d</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderBottomWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '4%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>e</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '23%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9.5%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%', borderRightWidth: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '9%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}></Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 15 }]}>
                    <View style={[styles.tableRow, { border: 1 }]}>
                        <View style={[styles.tableCol, { width: '50%', borderRightWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nahkoda kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Inspektur Mutu</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { paddingTop: 55, width: '50%', borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaNahkoda}</Text>
                        </View>
                        <View style={[styles.tableCol, { paddingTop: 55, width: '50%', borderRightWidth: 1, borderBottomWidth: 1, alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama</Text>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No. Reg</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DataUmumKapal